var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('span',{staticClass:"efficiency-test-status"},[_c('span',{class:['status-bullet', _vm.statusClass]}),_c('span',[_vm._v(_vm._s(_vm.statusText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }